import { Model } from 'pinia-orm'

import { Attr, BelongsTo, HasMany, Num, Uid } from 'pinia-orm/dist/decorators'
import { Transaction } from 'modules/Transaction/Transaction'
import { Client } from 'modules/Client/Client'
import { Tenant } from 'modules/Tenant/Tenant'
import { Org } from 'modules/Org/Org'

export class Site extends Model {
  static override entity = 'sites'

  @Uid() declare id: string
  @Num(null) declare int_id: number | null

  @Attr(null) declare site_number: number
  @Attr(null) declare name: string
  @Attr(null) declare client_id: string | null
  @Attr(null) declare address: string | null
  @Attr(null) declare description: string | null
  @Attr(null) declare is_active: boolean

  @BelongsTo(() => Client, 'client_id') declare client: Client | null
  @HasMany(() => Transaction, 'transaction_id') declare transactions: Transaction[]

  @Attr(null) declare tenant_id: string
  @Attr(null) declare org_id: number
  @BelongsTo(() => Tenant, 'tenant_id') declare tenant: Tenant | null
  @BelongsTo(() => Org, 'org_id') declare org: Org | null
}
